import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TopUpTicketPostModel } from './models/topup-ticket-post.model';
import { take } from 'rxjs/operators';
import { TicketWithBalanceModel } from './models/topup-ticket.model';

@Injectable({
  providedIn: 'root'
})
export class TopupTicketStore {
  constructor() {}

  private tickets = new BehaviorSubject<TicketWithBalanceModel[]>([]);
  tickets$ = this.tickets.asObservable();

  private topUpTickets = new BehaviorSubject<TopUpTicketPostModel[]>([]);
  topUpTickets$ = this.topUpTickets.asObservable();

  private topUpAmounts = new BehaviorSubject<number[]>([]);
  topUpAmounts$ = this.topUpAmounts.asObservable();

  public setTopUpAmounts(amounts: number[]) {
    this.topUpAmounts.next(amounts);
  }

  public setTickets(tickets: TicketWithBalanceModel[]) {
    this.tickets.next(tickets);
  }

  public addOrUpdateTicket(ticket: TicketWithBalanceModel) {
    this.tickets$
    .pipe(take(1))
    .subscribe(val => {
      const index = val.findIndex(t => t.BarcodeText === ticket.BarcodeText);
      if (index === -1) {
        const newArr = [...val, ticket];
        this.tickets.next(newArr);
      } else {
        val[index] = ticket;
        this.tickets.next(val);
      }
    });
  }

  public removeTicket(barcodeText: string) {
    this.tickets$
      .pipe(take(1))
      .subscribe(val => {
        const index = val.findIndex(t => t.BarcodeText === barcodeText);
        if (index !== -1) {
          val.splice(index, 1);
          this.tickets.next(val);
        }
      });
  }

  public clearAllTickets() {
    this.tickets.next(new Array<TicketWithBalanceModel>());
    this.clearAllTopUpTickets();
  }

  public addOrUpdateTopUpTicket(topUpTicket: TopUpTicketPostModel) {
    this.topUpTickets$
      .pipe(take(1))
      .subscribe(val => {
        const index = val.findIndex(t => t.barcodeText === topUpTicket.barcodeText);
        if (index === -1) {
          // Doesn't exist add new
          const newArr = [...val, topUpTicket];
          this.topUpTickets.next(newArr);
        } else {
          // Does exist update
          val[index] = topUpTicket;
          this.topUpTickets.next(val);
        }
    });
  }

  public removeTopUpTicket(barcodeText: string) {
    this.topUpTickets$
      .pipe(take(1))
      .subscribe(val => {
        const index = val.findIndex(t => t.barcodeText === barcodeText);
        if (index !== -1) {
          val.splice(index, 1);
          this.topUpTickets.next(val);
        }
      });
  }

  public clearAllTopUpTickets() {
    this.topUpTickets.next(new Array<TopUpTicketPostModel>());
  }
}
